import React from 'react';
import { Editor } from '@tiptap/react';
import type { CharacterCountOptions } from '@tiptap/extension-character-count';
import {
  isExtensionInstalled,
  getExtensionOptions,
} from '../../../utils/tiptap';

import s from './CharacterCount.scss';

interface Props {
  editor: Editor;
}

const CharacterCount: React.FC<Props> = ({ editor }) => {
  if (!isExtensionInstalled(editor, 'characterCount')) {
    return null;
  }

  const options: CharacterCountOptions =
    getExtensionOptions(editor, 'characterCount');
  const count = editor.storage.characterCount.characters();
  return (
    <span className={s['root']}>
      {parseInt(`${options.limit}`) - count}
    </span>
  );
};
CharacterCount.displayName = 'CharacterCount';

export default CharacterCount;
